export const iconFontAwesomeSportsFitnessHeart = (
	<i className="fa-solid fa-heart"></i>
);
